import React from "react";
import { Grid, CssBaseline, Box } from "@gti-controls-v2/web-core";
import consumosStyles from "../../common/styles/Consumos";
import appConfig from "../../config/app"


/** Estructura de Login */
export default function SeleccionarSolucionLayout(props) {
  const styles = consumosStyles;
  
  return (
    <Grid container component="main" sx={styles.root}>
      <CssBaseline />
      
      {props.children}
      <Box sx={styles.imageContainer}>
        {"Versión: " + appConfig.APP_VERSION }
      </Box>
    </Grid>
  );
}
